import './PageLoader.css';

/**
 * Single centralized loading-indicator visual, reused at three scopes:
 *  - full-page (default): fixed, fills the viewport -- used for the
 *    top-level auth/profile gate and every route's Suspense fallback (App.js).
 *  - route/page content (`overlay` + default `background`): still the same
 *    cube animation, sized down, absolutely positioned within the nearest
 *    positioned ancestor -- used by page-level data-fetch loading states
 *    (DashboardView, InsightsPage, AllDashboards, DashboardsSelector, Settings).
 *  - component-scoped (`overlay` + `size="sm"` + an opaque `background`
 *    matching the host's own loaded-state surface color): used inside an
 *    individual chart tile or a grant-access platform tile so that
 *    component's own in-flight fetch shows a loader independent of the
 *    page-level one.
 *
 * This is intentionally the ONE loading visual for the whole app (workspace
 * CLAUDE.md loader-centralization task) -- do not introduce a second spinner
 * component; pass `overlay`/`size`/`background` to adapt this one instead.
 */
export default function PageLoader({
  label = 'Loading',
  overlay = false,
  size = 'md',
  background,
}) {
  const classNames = [
    'pageLoader',
    overlay ? 'pageLoader--overlay' : '',
    size === 'sm' ? 'pageLoader--sm' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classNames}
      style={overlay && background ? { background } : undefined}
    >
      <div className="floatWrapper">
        <div className="cubeWrapper">
          <div className="cube">
            <div className="face front" />
            <div className="face back" />
            <div className="face left" />
            <div className="face right" />
            <div className="face top" />
            <div className="face bottom" />
          </div>
        </div>
      </div>

      <div className="shadow" />

      {label && (
        <div className="label" aria-label={label} aria-live="polite">
          {label}
          <span className="dot dot1" />
          <span className="dot dot2" />
          <span className="dot dot3" />
        </div>
      )}
    </div>
  );
}
